import { PropsWithChildren } from "react";
import { TermsAndConditionRoutes } from "ui/common/router/TermsAndConditionRouter.types";
import ProtectedRoute from "ui/router/components/ProtectedRoute/ProtectedRoute";
import useTermsAndConditionsUpdated from "ui/user/query/useAreTermsAndConditionsUpdated";

const TermsAndConditionsRoute = ({ children }: PropsWithChildren<object>): JSX.Element => {
    const { isLoading, areTermsAndConditionsUpdated } = useTermsAndConditionsUpdated();
    return (
        <ProtectedRoute isAllowed={areTermsAndConditionsUpdated || isLoading} redirectPath={TermsAndConditionRoutes.ACCEPT_TERMS}>
            {children}
        </ProtectedRoute>
    );
};

export default TermsAndConditionsRoute;
